import { defineActions } from './defineActions'

/**
 * Case details, case notes and case permissions. Action names start with CaseDetails. / CaseNote. /
 * CasePermission. These controls live in src/components (shared between modules), so the names
 * carry no module prefix: the module comes from the page's subject.
 *
 * The Booking Company / Claim Information form itself (QA Status, PIC, funding, claimant and
 * company picks, attachments) is saved by the page footer Save (Ime.BookingDetails.Save).
 */
export const caseDetailsActions = defineActions({
  'CaseDetails.CorrectionsStatus.Update': {
    label: 'Update corrections status',
    area: 'Case details',
    description: 'Corrections Status edit icon, then Save in the modal.',
  },
  'CaseDetails.AmendmentStatus.Update': {
    label: 'Update amendment status',
    area: 'Case details',
    description: 'Amendment Status edit icon, then Save in the modal.',
  },
  'CaseDetails.StaffAccess.Update': {
    label: 'Update location-based access',
    area: 'Case details',
    description:
      'Location-Based Access edit icon, then Save in the modal (case-level onshore override).',
  },
  'CaseDetails.Uhg.Connect': {
    label: 'Connect to UHG',
    area: 'Case details',
    description: '"Connect to UHG" link next to Reference/Claim No, then OK.',
  },
  'CaseDetails.Claimant.Create': {
    label: 'Add new claimant',
    area: 'Case details',
    description:
      'Claimant Add/Edit menu "Add Claimant", then Add in the modal.',
  },
  'CaseDetails.Claimant.Update': {
    label: 'Edit claimant',
    area: 'Case details',
    description:
      'Claimant Add/Edit menu "Edit Claimant", then Save in the modal (updates the claimant record).',
  },
  'CasePermission.Save': {
    label: 'Save case permission',
    area: 'Case details',
    description: '"Permissions:" link, then Save in the Case Permission modal.',
  },
  'CaseNote.Create': {
    label: 'Add case note',
    area: 'Case notes',
    description: 'Case Notes "Add Note", then Save in the modal.',
  },
  'CaseNote.Update': {
    label: 'Update case note',
    area: 'Case notes',
    description: 'Case Notes row "View", then Save in the modal.',
  },
  'CaseNote.Delete': {
    label: 'Delete case note',
    area: 'Case notes',
    description: 'Case Notes row "Delete", then OK.',
  },
})
